import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
// import { stockExport } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'
import { StockExport } from 'depoto-core'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class StockExportService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  // public async getstockExport(id): Promise<stockExport> {
  //     return new stockExport(
  //         await this.core.services.stockExport.getById(id, {
  //             // todo
  //             id: null,
  //         })
  //     )
  // }

  async getStockExports(
    // todo
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<{
    items: StockExport[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.stockExport.getList(parameters, schema)
  }

  // createCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {
  //     return this.core.services.checkout.createWithTanstack(checkout, schema)
  // }

  // updateCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {y
  //     return this.core.services.checkout.updateWithTanstack(checkout, schema)
  // }

  // deletestockExport(stockExport: Partial<stockExport>): Promise<stockExport> {todo
  //   return this.core.services.stockExport.dele(stockExport)
  // }
}
